import React from "react";
import { alert, t } from "../../../components/CustomComponent.js";
import { initials, avatarTone, fmtPhone, lineAddUrl } from "../../../components/people_option.js";
import ICON from "../icons.js";
import LINE_ICON from "../../../assets/images/icon-line.png";

/* ============================================================================
 * HomeCardContact — แถวติดต่อท้ายการ์ดทรัพย์/โครงการ
 *   รูปผู้ดูแลประกาศ (วงกลม) ชิดซ้าย ต่อด้วยปุ่มโทร แล้วปุ่มเพิ่มเพื่อน LINE
 *
 * ปุ่มโทรถามยืนยันก่อนเสมอ — การ์ดอยู่ในกริดที่เลื่อนด้วยนิ้ว ถ้ากดพลาดแล้ว
 * โทรออกทันทีจะแก้ไม่ทัน และหน้าจอที่โทรออกไม่ได้ (เดสก์ท็อป) จะได้เห็นเบอร์
 * ไว้กดโทรจากเครื่องอื่นด้วย
 *
 * ปุ่ม LINE เป็น <a> จริง เพราะต้องเปิดแอป LINE / หน้าเพิ่มเพื่อนได้เอง
 * และผู้ใช้กดค้างเพื่อคัดลอกหรือแชร์ลิงก์ต่อได้
 *
 * ทั้งแถวอยู่ในการ์ดที่กดแล้วเปิดหน้ารายละเอียด จึงต้อง stopPropagation
 * ไม่งั้นกดโทรแล้วจะเด้งไปเปิดหน้ารายละเอียดพร้อมกัน
 *
 * ไม่มีข้อมูลผู้ติดต่อเลย = ไม่แสดงแถวนี้ ดีกว่าโชว์ปุ่มที่กดแล้วไม่เกิดอะไร
 * ========================================================================== */
const stop = (e) => e.stopPropagation();

export default function HomeCardContact({ contact }) {
  if (!contact) return null;

  const line = lineAddUrl(contact.line);
  // tel: รับได้เฉพาะตัวเลขกับ + — เบอร์ที่พิมพ์มาเป็น 08X-XXX-XXXX ต้องล้างขีดออกก่อน
  const dial = String(contact.phone || "").replace(/[^\d+]/g, "");

  if (!contact.picture && !dial && !line) return null;

  const call = async (e) => {
    e.stopPropagation();
    const detail = [contact.name, fmtPhone(contact.phone)].filter(Boolean).join("\n");
    if (!(await alert("", "info", t("home_contact_call_confirm"), detail, t("home_contact_call"), t("cancel")))) return;
    window.location.href = `tel:${dial}`;
  };

  return (
    <div className="hm-card__foot" onClick={stop}>
      {/* ยังไม่ได้อัปรูป = อักษรย่อบนพื้นสีประจำคน ใช้ชุดสีเดียวกับหน้าผู้ใช้งานฝั่งแอดมิน
          (avatarTone) คนเดิมจึงได้สีเดิมทั้งสองฝั่ง ไม่ใช่คนละสีคนละหน้า

          ใส่พื้นสีเฉพาะตอนไม่มีรูป และแยกคลาส is-initial ไว้ให้ CSS ลดความเข้ม
          ได้โดยไม่ไปโดนรูปถ่ายจริงที่ไม่ควรถูกปรับความสว่าง */}
      <span
        className={`hm-card__avatar ${contact.picture ? "" : "is-initial"}`}
        title={contact.name}
        style={contact.picture ? undefined : { background: avatarTone(contact.name) }}
      >
        {contact.picture ? <img src={contact.picture} alt={contact.name || ""} /> : initials(contact.name)}
      </span>

      {!!dial && (
        <button
          type="button"
          className="hm-card__contact"
          title={`${t("home_contact_call")} ${fmtPhone(contact.phone)}`}
          aria-label={t("home_contact_call")}
          onClick={call}
        >
          <span className="hm-ico">{ICON.phone}</span>
        </button>
      )}

      {!!line && (
        <a
          className="hm-card__contact hm-card__contact--line"
          href={line}
          target="_blank"
          rel="noreferrer"
          title={t("home_contact_line_add")}
          aria-label={t("home_contact_line_add")}
          onClick={stop}
        >
          {/* โลโก้ LINE เป็นไฟล์ภาพจริง (assets/images/icon-line.png) ซึ่งมีวงกลม
              พื้นเขียวมาในตัว ปุ่มจึงไม่ต้องใส่พื้นหลังเอง — ดู .hm-card__contact--line */}
          <img src={LINE_ICON} alt="" />
        </a>
      )}
    </div>
  );
}
